module.exports = __webpack_public_path__ + "assets/img/close-main.d7c53f10.svg";